var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgManage = function SvgManage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    clipPath: "url(#manage_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.163.5a.5.5 0 0 1 .474.34l.873 2.582.01.031c.72.27 1.386.651 1.972 1.123a.494.494 0 0 1 .032-.007l2.717-.548a.5.5 0 0 1 .53.238l1.157 1.974a.5.5 0 0 1-.06.588l-1.83 2.034a.493.493 0 0 1-.023.023 6.94 6.94 0 0 1 0 2.244.537.537 0 0 1 .022.023l1.832 2.034a.5.5 0 0 1 .06.588L17.77 15.74a.5.5 0 0 1-.53.238l-2.717-.548a.544.544 0 0 1-.032-.007 7.126 7.126 0 0 1-1.972 1.123.49.49 0 0 1-.01.031l-.873 2.582a.5.5 0 0 1-.474.34H8.834a.5.5 0 0 1-.473-.34l-.874-2.582a.503.503 0 0 1-.01-.031 7.124 7.124 0 0 1-1.972-1.123.474.474 0 0 1-.031.007l-2.718.548a.5.5 0 0 1-.53-.238L1.07 13.767a.5.5 0 0 1 .06-.588l1.83-2.034a.549.549 0 0 1 .023-.023 6.946 6.946 0 0 1 0-2.244.509.509 0 0 1-.022-.023L1.128 6.82a.5.5 0 0 1-.06-.588L2.227 4.26a.5.5 0 0 1 .53-.238l2.718.548.03.007a7.127 7.127 0 0 1 1.973-1.123.505.505 0 0 1 .01-.031L8.36.84A.5.5 0 0 1 8.834.5h2.329Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 2.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "manage_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgManage;